module.exports = __webpack_public_path__ + "img/pro-pc1.80d74432.png";